import BaseComponent from '../base/baseComponent';
export default class HashNavigation extends BaseComponent {
    constructor(element) {
        super(element);
        if (location.hash) {
            const hashedEl = document.querySelector(location.hash);
            if (hashedEl) {
                document.documentElement.scrollTop = hashedEl.getBoundingClientRect().top - 60;
                hashedEl.focus();
            }
        }
    }
}
